module.exports = __webpack_public_path__ + "static/Sagar-Satam-CV2019-dd6babdd9c7d1dcc56337244c6c49cf5.pdf";